import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidVatReleaseReasonCustomNameError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.company.validation.vat-release-reason.required');
    }
}
